import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbTypeaheadModule, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { TicketInfrastructure, ZendeskFaq } from '@zero/tickets/domain';
import { Observable, OperatorFunction, debounceTime, map, switchMap } from 'rxjs';

@Component({
  selector: 'tickets-zendesk-faq-search',
  templateUrl: './zendesk-faq-search.component.html',
  styleUrls: ['./zendesk-faq-search.component.scss'],
  imports: [FormsModule, NgbTypeaheadModule],
})
export class ZendeskFaqSearchComponent {
  @Output() public createTicket = new EventEmitter<void>();
  public model: string;

  constructor(private readonly ticketInfrastructure: TicketInfrastructure) {}

  public search: OperatorFunction<string, readonly ZendeskFaq[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      switchMap((term) => this.ticketInfrastructure.getZendeskSuggestions(term)),
      map((suggestions) => [...suggestions, { title: 'Meine Anfrage ist leider nicht dabei', url: '' } as ZendeskFaq]),
    );

  public formatter = (x: ZendeskFaq): string => x.title;

  public itemSelected(faqItem: NgbTypeaheadSelectItemEvent<ZendeskFaq>): void {
    faqItem.preventDefault();
    if (faqItem.item.url) {
      window.open(`https://support.finanzen-zero.net${faqItem.item.url}`, '_blank');
    } else {
      this.createTicket.emit();
    }
  }
}
